module.exports = __webpack_public_path__ + "static/media/logo-gina.a9c0da2b.png";